<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">Select your character{{singleSelect ? '' : 's'}}</h5>
  <button
    (click)="modalService.closeOutletModals('characterSelect')"
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
  >
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="character-select-header">
    <div class="form-group">
      <input
        (keyup)="filterCharacters($event)"
        type="text"
        class="form-control character-list-search"
        placeholder="Search"
      >
    </div>
    <app-button *ngIf="!singleSelect" size="form" [block]="true" (clicked)="verifySelectedCharacters()">Select characters</app-button>
  </div>
  <div class="character-list">
    <div
      class="character-item"
      *ngFor="let character of availableCharacters"
      (click)="toggleCharacterSelection(character.name)"
      [class.active]="currentSelectedCharacters.indexOf(character.name) > -1"
    >
      <img
        alt="{{character.name}}"
        src="https://cdn.ggboost.com/images/champions/{{ character.name }}.jpg"
        class="character-avatar"
      >
    </div>
  </div>
</div>
